import React from "react";
import { useState,useEffect } from "react";
import shirrt from "../assets/icons/icon-shirrt.svg";
import text from "../assets/icons/icon-text.svg";
import elements from "../assets/icons/icon-elements.svg";
import upload from "../assets/icons/icon-upload.svg";
import search from "../assets/icons/icon-search.svg";
import downsm from "../assets/icons/icon-downsm.svg";
import mright from "../assets/icons/icon-mright.svg";
import Fonts from "./sideBarSubComponents/Fonts";
import Elements from "./sideBarSubComponents/Elements";
import Upload from "./sideBarSubComponents/Upload";
import { useDispatch, useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation } from "swiper/modules";
import Mockup from "./sideBarSubComponents/Mockup";

const Sidebar = () => {
  const activeTab = useSelector((state) => state.activeTab.activeTab);
  const dispatch = useDispatch();

  const [activeTool, setActiveTool] = useState("fonts");
  const [searchQuery, setSearchQuery] = useState("");



  const getTitleText = () => {
    if (activeTab === "previewMockup") {
      return "Mockups";
    }
    switch (activeTool) {
      case "elements":
        return "Elements";
      case "fonts":
        return "Fonts";
      case "upload":
        return "Uploads";
      default:
        return "Mockups";
    }
  };

  const getSearchPlaceholder = () => {
    if (activeTab === "previewMockup") {
      return " Search Mockups";
    }
    switch (activeTool) {
      case "elements":
        return "Search Elements";
      case "fonts":
        return "Search Fonts";
      case "upload":
        return "Search Uploads";
      default:
        return "Search Mockups";
    }
  };
 
  useEffect(() => {
    setSearchQuery("");
  }, [activeTab,activeTool]);

  return (
    <div id= "sidebar" className="  h-[100%] w-[273px]  ">
      <div className=" mt-[40px]  h-[660px] bg-white shadow-md ml-[12px]   rounded-lg ">
      <div className={`flex justify-around items-center ${activeTab === "previewMockup" ? "p-2 " : "p-4"}`}>

        {activeTab === "previewMockup" && (
          <div className="flex flex-col justify-between gap-[6px] p-2 cursor-pointer">
            <img
              src={shirrt}
              alt="Mockups Icon"
              className="w-[30px] h-[30px]"
            />
            <div
              className={`mx-auto h-[2px] w-[23px] ${
                activeTab === "previewMockup" ? "bg-red-500" : "bg-gray-400"
              }`}
            ></div>
          </div>
        )}

        {["editMockup", "editSVG"].includes(activeTab) && (
          <>
          
            <div
              onClick={() => setActiveTool("fonts")}
              className="flex flex-col justify-between gap-[6px] p-2 cursor-pointer"
            >
              <img src={text} alt="Text Icon" className="w-[27px] h-[30px]" />
              <div
                className={`mx-auto h-[2px] w-[23px] ${
                  activeTool === "fonts" ? "bg-red-500" : "bg-gray-400"
                }`}
              ></div>
            </div>
            <div
              onClick={() => setActiveTool("elements")}
              className="flex flex-col justify-between gap-[6px] p-2 cursor-pointer"
            >
              <img
                src={elements}
                alt="Elements Icon"
                className="w-[30px] h-[30px]"
              />
              <div
                className={`mx-auto h-[2px] w-[23px] ${
                  activeTool === "elements" ? "bg-red-500" : "bg-gray-400"
                }`}
              ></div>
            </div>
            <div
              onClick={() => setActiveTool("upload")}
              className="flex flex-col justify-between gap-[6px] p-2 cursor-pointer"
            >
              <img
                src={upload}
                alt="Upload Icon"
                className="w-[28px] h-[30px]"
              />
              <div
                className={`mx-auto h-[2px] w-[23px] ${
                  activeTool === "upload" ? "bg-red-500" : "bg-gray-400"
                }`}
              ></div>
            </div>
          </>
        )}
      </div>

      <div className="flex items-center justify-center px-4 text-[#383737] font-montserrat text-[16px] font-semibold leading-[19.5px]">
        {getTitleText()}
      </div>

      {activeTool !== "upload" && (
        <div className="flex items-center justify-center  relative p-4 ">
          <input
            type="text"
            placeholder={getSearchPlaceholder()}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)} 
            className="flex-1 border border-gray-300  bg-gray-100 text-[#383737] font-montserrat text-[12px] font-semibold leading-[12.5px] w-[241px] h-[26px] rounded px-3 py-2 pr-10 focus:outline-none"
          />
          <button className="absolute right-6 top-1/2 transform -translate-y-1/2">
            <img src={search} alt="Search Icon" className="w-17px h-17px" />
          </button>
        </div>
      )}

         <Mockup searchQuery={searchQuery} />

      {activeTab === "editMockup" || activeTab === "editSVG" ? (
        <div>
          {activeTool === "fonts" && <Fonts searchQuery={searchQuery} />}
          {activeTool === "elements" && <Elements searchQuery={searchQuery} />}
          {activeTool === "upload" && <Upload />}
        </div>
      ) : null}
      </div>
    </div>
  );
};

export default Sidebar;
